module.exports = __webpack_public_path__ + "static/media/arrowDown.61b31fcd.svg";